<template>
  <div class="pfslide" @click.stop>
    <div class="pfslide__title pfslide__title_smspace pfslide__title_microspace">
      СПАСИБО!
    </div>
    <div class="pfslide__subtitle pfslide__subtitle_center pfslide__subtitle_smspace">
      Данные приняты
    </div>
    <a :href="fileLink" target="_blank" class="popform__next" :class="{ 'popform__next_loading': loading }" tabindex="0">
      Скачать документ
    </a>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import slide from '../../mixins/slide.vue'
export default {
  name: 'slide8',
  mixins: [slide],
  computed: {
    ...mapState(['id', 'fileLink'])
  },
  mounted() {
    let pageactions = document.querySelector('.popform__pageactions')
    if (pageactions) {
      pageactions.removeAttribute('style')
      this.$el.append(pageactions)
      pageactions.querySelectorAll('button').forEach(btn => btn.addEventListener('click', (e) => e.preventDefault()))
    }
  }
}
</script>

<style lang="sass">
.pfslide 
  .pageactions
    width: 100%
    &__popform_flex
      display: flex
      >*
        margin: 0
        &:first-child
          margin-right: 20px
      @include from(360px)
        flex-direction: column
        width: 100%
        align-items: center
        >*
          max-width: 100% !important
        >*:first-child
          margin-bottom: 20px
          margin-right: 0
    &__btn:nth-child(n)
      &:not(.share)
        max-width: calc(50% - 9px)
    &__wrapper
      justify-content: center
    &__commentform textarea
      margin: 0 0 20px
    &__commenttext
      max-width: 676px

      
  .useful
    margin-top: 0
    margin-bottom: 0
    margin-right: 0
    justify-content: center
    >*
      margin-top: 12.5px
      margin-bottom: 12.5px        
    &__title
      margin-right: 0      
    &__yes:nth-child(n), &__no:nth-child(n)
      svg
        margin-left: 12px
    &__yes
      margin-right: 18px
  .share
    &__copy
      width: 100%
      text-align: center

.pfslide .popform__pageactions
  display: block
  overflow: hidden !important
  justify-content: center
  .pageactions__comments:not(.active), .pageactions__main:not(.active)
    top: -1000px !important
  .pageactions__wrapper    
    display: flex
    flex-direction: column
    flex-wrap: nowrap
  .useful
    justify-content: center
    align-items: center
    flex-direction: column
    margin: 0
    .useful__title
      text-align: center
      margin: 0 0 12.5px
    .useful__buttons
      margin: 12.5px 0

    
</style>